if (!customElements.get('wlsn-buybox-with-options-new')) {
    class WLSNBuyboxWithOptionsNew extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          selected: 'is-selected',
          active: 'is-active',
          modal: 'js-wlsn-buybox-with-options-new-modal',
          modalClose: 'js-wlsn-buybox-with-options-new-modal-close',
          modalTrigger: 'js-wlsn-buybox-with-options-new-option-modal-trigger',
          buyNowPrice: 'js-wlsn-buybox-with-options-new-buy-now-price',
          swiper: 'js-wlsn-buybox-with-options-new-gallery',
          thumbs: 'js-wlsn-buybox-with-options-new-thumbs',
          list: 'swiper-wrapper',
          item: 'swiper-slide',
          
          navigation: {
            prev: 'js-wlsn-buybox-with-options-new-gallery-prev',
            next: 'js-wlsn-buybox-with-options-new-gallery-next',
            progressbar: 'js-wlsn-buybox-with-options-new-gallery-pagination'
          }
        };

        this.elements = {
          slider: this.querySelector(`.${this.classes.swiper}`),
          thumbs: this.querySelector(`.${this.classes.thumbs}`),
          list: this.querySelector(`.${this.classes.list}`),
          items: this.querySelectorAll(`.${this.classes.item}`),
          modal: this.querySelector(`.${this.classes.modal}`),
          modalClose: this.querySelector(`.${this.classes.modalClose}`),
          modalTrigger: this.querySelector(`.${this.classes.modalTrigger}`),
          buyNowPrice: this.querySelectorAll(`.${this.classes.buyNowPrice}`),
          navigation: {
            prev: this.querySelector(`.${this.classes.navigation.prev}`),
            next: this.querySelector(`.${this.classes.navigation.next}`),
            progressbar: this.querySelector(`.${this.classes.navigation.progressbar}`)
          }
        }

        this.resizeHandler = this.handleResize.bind(this);
        this.isSubmitting = false;
      }
  
      connectedCallback() {
        if (this.checkIfEmpty()) return;
        this.init();
      }
  
      init() {
        this.addEventListener('click', this.handleClick);
  
        const firstMain = this.querySelector('.js-wlsn-buybox-with-options-new-option-main');
        if (firstMain) {
          this.selectMain(firstMain);
        }

        if (!this.shouldInitialize()) return;
        this.initializeSwiper();

        this.updatePrice();
      }

      checkIfEmpty() {
        const listInner = this.elements.list;
        if (!listInner || !listInner.children.length) {
          this.style.display = 'none';
          return true;
        }
        return false;
      }

      shouldInitialize() {
        return this.elements.items.length > 1;
      }
  
      handleResize() {
        if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
  
        this.resizeTimeout = setTimeout(() => {
          const shouldInit = this.shouldInitialize();
  
          if (shouldInit && !this.swiper) {
            this.initializeSwiper();
          } else if (!shouldInit && this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        }, 300);
      }
  
      initializeSwiper() {
        if (!this.elements.thumbs || !this.elements.slider) return;
  
        this.thumbs = new Swiper(this.elements.thumbs, {
          spaceBetween: 8,
          direction: 'horizontal',
          slidesPerView: 'auto',
          watchSlidesProgress: true
        });
  
        this.swiper = new Swiper(this.elements.slider, {
          slidesPerView: 1,
          spaceBetween: 10,
          watchSlidesProgress: true,
          navigation: {
            prevEl: this.elements.navigation?.prev,
            nextEl: this.elements.navigation?.next
          },
          pagination: {
            el: this.elements.navigation?.progressbar,
            clickable: true
          },
          thumbs: { swiper: this.thumbs }
        });
      }
  
  
      // Handle clikc events 
      handleClick = (e) => {
        const main = e.target.closest('.js-wlsn-buybox-with-options-new-option-main');
        const care = e.target.closest('.js-wlsn-buybox-with-options-new-option-care');
        const buy = e.target.closest('.js-buy-now');
        const modalTrigger = e.target.closest(`.${this.classes.modalTrigger}`);
        const modalClose = e.target.closest(`.${this.classes.modalClose}`);
  
        if (main) {
          this.selectMain(main);
          return;
        }
  
        if (care) {
          this.toggleCare(care);
          return;
        }
  
        if (buy) {
          this.goToCart();
          return;
        }
        if (modalTrigger) {
            this.openModal();
            return;
          }
        
          if (modalClose) {
            this.closeModal();
            return;
          }

          if (this.elements.modal && e.target === this.elements.modal) {
            this.closeModal();
          }
      };
  
      // Select main option
      selectMain(option) {
        this.querySelectorAll('.js-wlsn-buybox-with-options-new-option-main')
          .forEach(el => el.classList.remove(this.classes.selected));
  
        option.classList.add(this.classes.selected);
        this.updatePrice();
      }
  
      // Select care option
      toggleCare(option) {
        const isSelected = option.classList.contains(this.classes.selected);
  
        this.querySelectorAll('.js-wlsn-buybox-with-options-new-option-care')
          .forEach(el => el.classList.remove(this.classes.selected));
  
        if (!isSelected) {
          option.classList.add(this.classes.selected);
        }
        this.updatePrice();
      }
  
     
      async goToCart() {
        const buyButton = this.querySelector('.js-buy-now');
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        buyButton?.classList.add('is-loading');

        const main = this.querySelector('.js-wlsn-buybox-with-options-new-option-main.is-selected');
        const care = this.querySelector('.js-wlsn-buybox-with-options-new-option-care.is-selected');
        const discountCode = care?.dataset.discountCode;
      
        console.log('DISCOUNT CODE:', discountCode);
      
        if (!main) {
          console.warn('No main product selected');
          return;
        }
      
        const items = [
          {
            id: main.dataset.variantId,
            quantity: 1
          }
        ];
      
        if (care && care.dataset.variantId) {
          const item = {
            id: care.dataset.variantId,
            quantity: 1
          };
      
          if (care.dataset.sellingPlanId) {
            item.selling_plan = care.dataset.sellingPlanId;
          }
      
          items.push(item);
        }
      
        console.log('FINAL CHECKOUT ITEMS:', items);
      
        try {
         
          await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          });
      
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          });
      
          if (discountCode) {
            window.location.href = `/checkout?discount=${discountCode}&skip_shop_pay=true`;
          } else {
            window.location.href = '/checkout?skip_shop_pay=true';
          }
      
        } catch (err) {
          console.error('Cart error:', err);
        }
        finally {
          this.isSubmitting = false;
          buyButton?.classList.remove('is-loading');
        }
      }

      openModal() {
        if (!this.elements.modal) return;
      
        this.elements.modal.classList.add(this.classes.active);
        document.body.classList.add('body-lock');
      }
      
      closeModal() {
        if (!this.elements.modal) return;
      
        this.elements.modal.classList.remove(this.classes.active);
        document.body.classList.remove('body-lock');
      }

      updatePrice() {
        const main = this.querySelector('.js-wlsn-buybox-with-options-new-option-main.is-selected');
        const care = this.querySelector('.js-wlsn-buybox-with-options-new-option-care.is-selected');
      
        let total = 0;
      
        if (main?.dataset.price) {
          total += parseInt(main.dataset.price, 10);
        }
      
        if (care?.dataset.price) {
          total += parseInt(care.dataset.price, 10);
        }
      
        const formatted = (total / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          });
      
        this.elements.buyNowPrice.forEach(el => {
          el.textContent = `${formatted}`;
        });
      }
    }
  
    customElements.define('wlsn-buybox-with-options-new', WLSNBuyboxWithOptionsNew);
  }